// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2G_zg","textarea":"styles_textarea__23he8"};